import { useCallback, Dispatch } from 'react';

function useAction<T, K>(dispatch: Dispatch<K>, action: (param: T) => K): (param: T) => void {
    return useCallback((param) => dispatch(action(param)), [dispatch, action]);
}

export default useAction;
